import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import { getSubtitle } from './BillingCellSubtitle.utils';
export const GetBillingCellSubtitleTID = (parentTestId)=>getTestIds(parentTestId);
export const BillingCellSubtitle = (param)=>{
    let { service, testId } = param;
    const testIds = useMemo(()=>GetBillingCellSubtitleTID(testId), [
        testId
    ]);
    const { t } = useLocaleKeys();
    const subtitle = useMemo(()=>getSubtitle(service, t), [
        service
    ]);
    if (!subtitle) return null;
    return /*#__PURE__*/ _jsx(Typography, {
        testId: testIds.BillingCellSubtitleTestIds.Text(),
        variant: "paragraph2",
        skin: "secondary",
        ellipsis: true,
        children: subtitle
    });
};
